'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, ReactNode } from 'react';
import type { SheetNavigationList } from './SheetManager';

/**
 * Context that browser components (ObjectBrowser, ObjectMapBrowser) use to
 * provide a navigation list to child card components. When a card opens a
 * detail sheet, the sheet hooks can pick up this context to enable prev/next
 * navigation through the loaded items.
 */

interface BrowserNavigationContextType {
  /** Navigation list for entities currently loaded in the browser */
  entityNavigationList?: SheetNavigationList;
  /** Navigation list for initiatives currently loaded in the browser */
  initiativeNavigationList?: SheetNavigationList;
  /** Navigation list for items currently loaded in the browser */
  itemNavigationList?: SheetNavigationList;
}
const BrowserNavigationContext = createContext<BrowserNavigationContextType>({});
export function BrowserNavigationProvider(t0) {
  const $ = _c(7);
  const {
    children,
    entityNavigationList,
    initiativeNavigationList,
    itemNavigationList
  } = t0;
  let t1;
  if ($[0] !== entityNavigationList || $[1] !== initiativeNavigationList || $[2] !== itemNavigationList) {
    t1 = {
      entityNavigationList,
      initiativeNavigationList,
      itemNavigationList
    };
    $[0] = entityNavigationList;
    $[1] = initiativeNavigationList;
    $[2] = itemNavigationList;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <BrowserNavigationContext.Provider value={t1}>{children}</BrowserNavigationContext.Provider>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}

/** Returns the browser navigation context (if any). Safe to call outside a provider — returns empty object. */
export function useBrowserNavigation() {
  return useContext(BrowserNavigationContext);
}